<!-- <mat-spinner color="accent" diameter="80"></mat-spinner> -->
<div class="spinner-container">
	<div class="spinner-wrapper">
		<svg height="100%" viewBox="0 0 32 32" width="100%">
			<circle cx="16" cy="16" fill="none" r="14" stroke-width="4" style="stroke: var(--branding--loading-spinner--backcolour);"></circle>
			<circle cx="16" cy="16" fill="none" r="14" stroke-width="4" style="stroke: var(--branding--loading-spinner--forecolour); stroke-dasharray: 80px; stroke-dashoffset: 60px;"></circle>
		</svg>
	</div>
</div>

